import { useEffect, useState } from "react";

function IsHydrated({ children }) {
  const [hydrated, setHydrated] = useState(false);
  useEffect(() => {
    setHydrated(true);
  }, []);

  if (!hydrated) {
    return null;
  }

  return children;
}

export default IsHydrated;
